import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiStar } from 'react-icons/fi';
import { FaQuoteLeft } from 'react-icons/fa';

const Testimonials = () => {
  const reviews = [
    {
      name: "Brandon Hutchins",
      role: "President & CEO, Gaskins",
      text: "Unbelievably powerful. I now have a myriad of practical leadership tools to implement inside my organizations."
    },
    {
      name: "Angela Cottrell",
      role: "Director of HR, Bailey International",
      text: "I am overwhelmed by the clarity that this process has brought to our Executive Team. Understanding each of our wiring & voices has brought us together as a team and has begun to guide our decisions within our organization to ensure each team member is in the right seat. It has been amazing to watch all of the participants and teams comes to life!"
    },
    {
      name: "Andrew Dahl",
      role: "CEO, Dahl Automotive",
      text: "This has been the largest factor in transforming my leadership and has resulted in tremendous growth."
    },
    {
      name: "John DeAngelis",
      role: "Founder, DeAngelis Diamond Construction Co.",
      text: "WOW. I quickly realized how unconsciously incompetent I was in many areas of leadership at work and at home. Our teams feel more supported and challenged than ever and we are already seeing the fruit of this program with increased productivity, morale and better attitudes all around."
    },
    {
      name: "Mickey Daniell",
      role: "Learning Power Team Lead, Southern Company",
      text: "It is much more than a program. It’s guidance, practical, and life changing. It has made me a better person, husband, father, and general leader in all circles of influence."
    },
    {
      name: "Marilyn",
      role: "Mid-manager, McDonald’s",
      text: "She’s very empowering she can make the whole room feel emotion that we block out and she makes me feel like I can progress in many things moving forward work life home life and this makes me a better person and she doesn’t understand what she has done for me today"
    }
  ];

  return (
    <section id="testimonials" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-24">
          <h2 className="text-5xl font-black text-brand-black mb-4">What Leaders <span className="text-brand-purple">Say.</span></h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto font-medium">
            Real feedback from leaders who have moved from overwhelmed to empowered.
          </p>
        </div>

        {/* Masonry Layout for varying text lengths */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8 md:space-y-0">
          {reviews.map((r, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="break-inside-avoid mb-8 bg-gray-50 p-10 rounded-[2.5rem] border border-gray-100 relative overflow-hidden group flex flex-col hover:shadow-lg transition-all duration-300"
            >
              <SafeIcon icon={FaQuoteLeft} className="absolute -top-4 -right-4 w-24 h-24 text-brand-purple/5 group-hover:text-brand-purple/10 transition-colors" />
              
              <div className="flex space-x-1 mb-6 relative z-10">
                {[1, 2, 3, 4, 5].map(s => (
                  <SafeIcon key={s} icon={FiStar} className="text-brand-purple w-4 h-4 fill-current" />
                ))}
              </div>
              
              <p className="text-lg font-bold text-brand-black mb-8 leading-relaxed relative z-10">
                "{r.text}"
              </p>
              
              <div className="relative z-10 mt-auto">
                <div className="font-black text-brand-black text-lg leading-tight mb-1">{r.name}</div>
                <div className="text-brand-purple font-bold text-xs uppercase tracking-wider">{r.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;